<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="form.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="创建人" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人" v-trim/>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入编辑人" v-trim/>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="form.info" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="退款编码" prop="code">
        <el-input v-model="form.code" placeholder="请输入退款编码" v-trim/>
      </el-form-item>
      <el-form-item label="用户编码（关联member表）" prop="memberId">
        <el-input v-model="form.memberId" placeholder="请输入用户编码（关联member表）" v-trim/>
      </el-form-item>
      <el-form-item label="交易金额" prop="money">
        <el-input v-model="form.money" placeholder="请输入交易金额" v-trim/>
      </el-form-item>
      <el-form-item label="状态 0预退款 1退款失败 2退款完成" prop="status">
        <el-input v-model="form.status" placeholder="请输入状态 0预退款 1退款失败 2退款完成" v-trim/>
      </el-form-item>
      <el-form-item label="交易预订单号" prop="preOrderid">
        <el-input v-model="form.preOrderid" placeholder="请输入交易预订单号" v-trim/>
      </el-form-item>
      <el-form-item label="在线交易单号" prop="onlineOrderid">
        <el-input v-model="form.onlineOrderid" placeholder="请输入在线交易单号" v-trim/>
      </el-form-item>
      <el-form-item label="退款方式 0微信 1支付宝" prop="payWay">
        <el-input v-model="form.payWay" placeholder="请输入退款方式 0微信 1支付宝" v-trim/>
      </el-form-item>
      <el-form-item label="完成时间" prop="doneDate">
        <el-date-picker v-model="form.doneDate" value-format="yyyy-MM-dd" placeholder="请输入完成时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="退款类型 0结算退款 1强制结算退款 2结算后退款" prop="type">
        <el-input v-model="form.type" placeholder="请输入退款类型 0结算退款 1强制结算退款 2结算后退款" v-trim/>
      </el-form-item>
      <el-form-item label="退款关联订单编码" prop="objId">
        <el-input v-model="form.objId" placeholder="请输入退款关联订单编码" v-trim/>
      </el-form-item>
      <el-form-item label="退款原因" prop="reason">
        <el-input v-model="form.reason" placeholder="请输入退款原因" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaRefundWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        info: '',
        code: '',
        memberId: '',
        money: '',
        status: '',
        preOrderid: '',
        onlineOrderid: '',
        payWay: '',
        doneDate: '',
        type: '',
        objId: '',
        reason: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/refund',
      'field.id': 'id'
    })
  }
}
</script>
